import type { ITableSorting } from '@model/tableSorting';

type ISortKeys = {
  id: number;
  name: string;
  facilityType: string;
  productionType: string;
  country: string;
  language: string;
  status: string;
};

export const getSortedData = (sort: ITableSorting, items?: Array<any>) => {
  if (!items?.length) return [];
  if (!sort.id) return items;
  const sortId = sort.id as keyof ISortKeys;

  return [...items].sort((a, b) =>
    !sort.desc ? a[sortId]?.localeCompare(b[sortId]) : b[sortId]?.localeCompare(a[sortId]),
  );
};
